import { DashboardRepository } from '../data/dashboard-repository';
import { MachineMapPoint } from '../types/dashboard-types';

export class GetFleetMapUseCase {
  constructor(private readonly repository: DashboardRepository) {}

  async execute(): Promise<{ points: MachineMapPoint[]; hasError: boolean; errorMessage?: string }> {
    try {
      const points = await this.repository.getFleetMap();
      return { points, hasError: false };
    } catch (error) {
      return {
        points: [],
        hasError: true,
        errorMessage: error instanceof Error ? error.message : 'Failed to load map data',
      };
    }
  }
}
